import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const SOSButton = () => {
  const navigate = useNavigate();

  const handleSOS = () => {
    // Efface l'historique et redirige
    window.history.replaceState(null, "", "/panic");
    navigate("/panic", { replace: true });
  };

  return (
    <Button
      variant="destructive"
      size="icon"
      onClick={handleSOS}
      className="fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-[max(1rem,env(safe-area-inset-right))] z-[60] h-14 w-14 rounded-full shadow-sos transition-transform hover:scale-105 sm:h-16 sm:w-16"
      aria-label="Sortie d'urgence"
      title="Sortie d'urgence"
    >
      <AlertTriangle className="h-8 w-8" />
    </Button>
  );
};
